'use client'

import { createContext } from 'react'

/** @type {import('react').Context<import('zustand').StoreApi | null>} */
export const NotebookStoreContext = createContext(null)
